/**
 * StorageComment
 */
let INSTANCE: StorageComment;

class StorageComment {
  private storageKey: string;
  private articleWriter: any;

  constructor() {
    this.storageKey =
      (window as any).userData && (window as any).userData.site
        ? (window as any).userData.site + "_alerts"
        : "nc-community";
    this.articleWriter;

    if (!INSTANCE) {
      INSTANCE = this;
    }

    return INSTANCE;
  }

  public set(data: any) {
    const _articleId = data.articleId;
    const _commentCount = data.commentCount;
    const _storageValue = this.get();
    let storageValue = _storageValue ? _storageValue : {};

    this.articleWriter = data.writer;

    storageValue[_articleId] = _commentCount;
    localStorage.setItem(this.storageKey, JSON.stringify(storageValue));
  }

  public get() {
    return JSON.parse(localStorage.getItem(this.storageKey));
  }

  public getArticleWriter(){
    return this.articleWriter;
  }
}

export default new StorageComment();
